// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useContext, Fragment} from 'react';
// @ts-ignore
import {App_context} from '../../../context';
import www_util from 'hola_pub_util';
import {get_host} from '../../../ui/legal/host';
import {use_translation_v} from '../../../lib/trans_v';
// @ts-ignore
import {useTranslation} from 'react-i18next';
import {Settings_context} from '../../../settings_ctx';
import {Doc} from '../../../ui/legal/doc';
import styles from './privacy.module.less';
import {use_webos_scroll} from './use_webos_scroll';
import {Text_privacy} from '../../../ui/legal/text_privacy';

export const Privacy = props=>{
    const {t} = use_translation_v();
    return <Fragment>
      <div className={styles.header}>
        <h1>{t('legal.privacy.title')}</h1>
      </div>
      <p><i className={styles.updated}>{t('legal.privacy.updated')}</i></p>
      <Text_privacy host={get_host(props)}/>
    </Fragment>;
};

export const Root = function Privacy_root(props){
    // @ts-ignore
    const {user} = useContext(App_context);
    const {i18n} = useTranslation();
    const {theme_name} = useContext(Settings_context);
    use_webos_scroll();
    useEffect(()=>void www_util.perr_www_visit({id: 'www_privacy_visit',
        user}), []);
    if (theme_name=='hola2023')
    {
        return <Doc cls={styles.privacy}>
          <Privacy {...props}/>
        </Doc>;
    }
    return <div className="basic_page-wrapper"
      dir={www_util.lng_dir(i18n.language)}>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <Privacy {...props}/>
          </div>
        </div>
      </div>
    </div>;
};

Root.meta = {
    exact: true,
    nosearch: true,
    ssr_force: true,
    translation: {enabled: false, detect_by_country: false,
        white_list: ['en', 'es', 'ru', 'de', 'fr', 'he']},
    meta: {
        title: 'Hola | Privacy Policy. What Information We Collect',
        description: 'We are committed to safeguarding your privacy & '
            +'ensuring transparency in our data practices. Learn how we '
            +'handle your information & your rights as a user here.',
        canonical_url: 'https://hola.org/legal/privacy',
    },
};
